module.exports = __webpack_public_path__ + "static/media/art52.2099a56f.jpg";